import * as React from 'react';
import { withStyles, StyledComponentProps, Grid, Typography } from '@material-ui/core';
// import { contact } from '../../../../model/contact';
import RoomItem from './RoomItem';
import { room } from '../../../../model/room';
import { styles } from './styles';
import { contact } from '../../../../model/contact';
import { myroom } from '../../../../model/myroom';


interface IProps extends StyledComponentProps {
    roomList: Array<room>;
    contact: contact;
    updatingRoomsPermissions: boolean;
    addRoom: (sub: string, room: myroom) => any;
    removeRoom: (sub: string, roomId: string) => any;
    updateRoom: (sub: string, room: myroom) => any;
}

const RoomList = (props: IProps) => {
    return (<>
        <Grid item xs={12} >
            <Typography style={{ fontWeight: "bold", marginTop: "10px" }}>Abilitazione Accesso Struttura</Typography>
        </Grid>
        <Grid container className={props.classes.root} style={{ maxHeight: "300px", overflowY: "auto" }}>
            {props.roomList && props.roomList.map(r =>
                <RoomItem
                    updatingRoomsPermissions={props.updatingRoomsPermissions}
                    room={r}
                    key={r._id}
                    contact={props.contact}
                    addRoom={props.addRoom}
                    removeRoom={props.removeRoom}
                    updateRoom={props.updateRoom}
                />)}

        </Grid>
    </>
    );
}
export default withStyles(styles)(RoomList)